import React, { useEffect, useState } from "react";

import Seo from "../layouts/common/seo";
import HomeBanner from "./home_banner/index";
// import ShopByCategoryNew from "./shop_by_category/index";
import HomeShopByCategory from "./home_shop_by_category/HomeShopByCategory";
import HomeVideoSection from "./home_video_section/HomeVideoSection";
// import GiftsIdeas from "./gift_ideas/index";
import HomeGiftIdeas from "./home_gift_ideas/HomeGiftIdeas";
import HomeNewBanner from "./home_new_banner/HomeNewBanner";
// import ChooseYourStyleBlog from "./choose_your_style/index";
// import Glitz from "./putting_on_the_glitz/index";
import HomeGlitz from "./home_glitz/HomeGlitz";
// import ShopNowAd from "./shop_now_ad/index";
// import BehingTheScene from "./behing_the_scene/index";
import GoogleReview from "../new_template_common/google_review/index";
import TestimonialsHome from "./testimonials_home/index";
import FeaturedIn from "./featured_in/index";
// import NewTrend from "./new_trend/index";
import Promise from "./promise/index";
// import TrendingProducts from "./trending_products/product-slider";
import HomeTrendingProducts from "./trending_products/HomeTrendingProducts";
import VideoAds from "./videoAds";
import CategoryShowcase from "./category_showcase/index";
import HomeFeaturedIn from './featured_in/HomeFeaturedIn';
import SunnyPromise from "../new_pdp/components/sunnyPromise";
import FooterSeo from "./footer_seo/FooterSeo";

// import InstagramWidget from "../new_template_common/instagram_widget/index";
// import algoliasearch from 'algoliasearch/lite';

const NewHomePage = () => {
  const [lookbook, setLookbook] = useState([]);
  const [trending, setTrending] = useState([]);

  // const searchClient = algoliasearch(window.rc.algoliasearch.appId, window.rc.algoliasearch.apiKey);
  // const index = searchClient.initIndex(window.rc.algoliasearch.defaultIndex);

  useEffect(() => {
    if (window.ApplicationTagEmbed) window.ApplicationTagEmbed.init();

    // index
    //     .search("", {
    //         hitsPerPage: 20,
    //         facetFilters: [`trending:true`]
    //     })
    //     .then(({ hits }) => {
    //         setLookbook(hits.reverse().slice(0, 10));
    //         setTrending(hits.slice(0, 10));
    //     })
    //     .catch(error => console.error(error));

    // Injected by an external tag — absent if that script fails to load.
    const trendingProducts = window.trending_products;
    if (!Array.isArray(trendingProducts)) return;

    setLookbook([...trendingProducts].reverse().slice(0, 10));
    setTrending(trendingProducts.slice(0, 10));
  }, []);

  // Add Organization and LocalBusiness schemas to document head
  useEffect(() => {
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Sunny Diamonds",
      alternateName: "Sunny Diamonds",
      url: "https://sunnydiamonds.com/",
      logo:
        "https://sunnydiamonds.com/assets/images/sunny/logo/logo15022023/Logo_desktop.svg",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91 9744 355 555",
          contactType: "customer service",
          areaServed: "IN",
          availableLanguage: ["en", "Malayalam"],
        },
        {
          "@type": "ContactPoint",
          telephone: "+91 9961 870 099",
          contactType: "technical support",
          areaServed: "IN",
          availableLanguage: ["en", "Malayalam"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/SunnyDiamonds.jewellery",
        "https://x.com/SunnyDiamond_4c",
        "https://www.instagram.com/sunnydiamondsofficial/",
        "https://www.youtube.com/user/sunnydiamondsads",
        "https://www.linkedin.com/company/sunny-diamonds/",
        "https://in.pinterest.com/sunnydiamonds/",
      ],
    };

    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Sunny Diamonds",
      image:
        "https://sunnydiamonds.com/assets/images/sunny/logo/logo15022023/Logo_desktop.svg",
      "@id": "",
      url: "https://sunnydiamonds.com/",
      telephone: "+91 9744 355 555",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "Sunny Diamonds Kochi 40/9134 B & C, Rajaji Rd, Ernakulam",
        addressLocality: "Ernakulam",
        postalCode: "682035",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        opens: "10:00",
        closes: "20:00",
      },
      sameAs: [
        "https://www.facebook.com/SunnyDiamonds.jewellery",
        "https://www.instagram.com/sunnydiamondsofficial/",
        "https://x.com/SunnyDiamond_4c",
        "https://www.youtube.com/user/sunnydiamondsads",
        "https://in.pinterest.com/sunnydiamonds/",
        "https://www.linkedin.com/company/sunny-diamonds/",
      ],
    };

    // Create Organization schema script
    const orgScript = document.createElement("script");
    orgScript.type = "application/ld+json";
    orgScript.id = "organization-schema";
    orgScript.textContent = JSON.stringify(organizationSchema);

    // Create LocalBusiness schema script
    const businessScript = document.createElement("script");
    businessScript.type = "application/ld+json";
    businessScript.id = "local-business-schema";
    businessScript.textContent = JSON.stringify(localBusinessSchema);

    // Add to head
    document.head.appendChild(orgScript);
    document.head.appendChild(businessScript);

    // Cleanup function to remove scripts when component unmounts
    return () => {
      const existingOrgScript = document.getElementById("organization-schema");
      const existingBusinessScript = document.getElementById(
        "local-business-schema"
      );
      if (existingOrgScript) {
        document.head.removeChild(existingOrgScript);
      }
      if (existingBusinessScript) {
        document.head.removeChild(existingBusinessScript);
      }
    };
  }, []); // Empty dependency array - only run once on mount

  return (
    <main className="site-main">
      <Seo type="sunny-head" canonical="https://sunnydiamonds.com/" />
      <HomeNewBanner />
      <HomeShopByCategory />
      <CategoryShowcase />
      <HomeTrendingProducts searchResults={trending} />
      <HomeVideoSection />
      <HomeGiftIdeas />
      {/* <VideoAds/> */}
      {/* <ChooseYourStyleBlog /> */}
      {/* <Glitz searchResults={lookbook} /> */}
      <HomeGlitz searchResults={lookbook} />
      {/* <ShopNowAd /> */}
      {/* <BehingTheScene /> */}
      {/* <FeaturedIn /> */}
      <HomeFeaturedIn />
      {/* <GoogleReview /> */}
      <TestimonialsHome />
      {/* <NewTrend /> */}
      {/* <InstagramWidget /> */}
      <SunnyPromise />
      <FooterSeo />
    </main>
  );
};
export default NewHomePage;
